import classNames from 'classnames';
import styles from '../styles.module.scss';

export interface CountPillProps {
  count?: number | null;
  /** danger (mặc định: việc đang chờ) · accent · muted (số 0 / số chỉ để biết). */
  tone?: 'danger' | 'accent' | 'muted';
  /** Không hiện gì khi số là 0 / chưa có (nhãn tab, nhãn nhóm). Mặc định: hiện "0" màu nhạt. */
  hideZero?: boolean;
  /** Bấm được (vd. mở tab Đề nghị lọc theo Studio): vẽ thành nút. */
  onClick?: () => void;
  title?: string;
}

/**
 * Ô đếm tĩnh trong trang Studio (SPEC mục 8.6): bản sao nhỏ của CountPill trong layouts/components/menu.tsx
 * (component đó không export; không sửa menu.tsx chỉ để export). Không dùng antd Badge cho số.
 */
const CountPill = ({ count, tone = 'danger', hideZero = false, onClick, title }: CountPillProps) => {
  const value = typeof count === 'number' && Number.isFinite(count) ? count : 0;
  if (value <= 0 && hideZero) return null;
  const className = classNames(styles.countPill, {
    [styles.countPillMuted]: value <= 0 || tone === 'muted',
    [styles.countPillAccent]: value > 0 && tone === 'accent',
  });
  const text = value > 99 ? '99+' : String(value);
  if (onClick) {
    return (
      <button
        type="button"
        className={className}
        onClick={onClick}
        title={title}
        aria-label={title ? `${title}: ${value}` : String(value)}
      >
        {text}
      </button>
    );
  }
  return (
    <span className={className} title={title}>
      {text}
    </span>
  );
};

export default CountPill;
